import React from "react";
import { useCruise } from "../context/CruiseContext";
import { MapPin, Clock, Compass, ArrowRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { blog } from "../seo/schema";

const Destinations = () => {
  const { PORTS, EVENT } = useCruise();
  const route = useLocation().pathname.replace(/\/+$/, "");
  const post = blog.posts.find((p) => p.booking === route);
  return (
    <section id="ports" className="relative bg-[#0A0A0A] py-24">
      <div className="max-w-7xl mx-auto px-5">
        <div className="text-center mb-16">
          <p className="font-cond uppercase tracking-[0.4em] text-[#E50914] text-sm mb-3">Where We Dock</p>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl">
            The <span className="text-[#E50914]">Ports</span>
          </h2>
          <div className="flex justify-center mt-4">
            <span className="section-line" />
          </div>
          <p className="mt-5 text-white/60 max-w-2xl mx-auto">
            {EVENT.portsIntro}
          </p>
          {post && (
            <Link
              to={`/blog/${post.slug}`}
              data-testid="ports-read-story-link"
              className="mt-4 inline-flex items-center gap-2 font-cond uppercase tracking-widest text-sm text-[var(--hh-gold)] hover:text-white transition-colors"
            >
              Read the story <ArrowRight size={15} />
            </Link>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PORTS.map((port, i) => (
            <div
              key={port.name}
              className={`relative overflow-hidden rounded-2xl group h-72 ${
                i === 0 ? "lg:col-span-2 lg:h-72" : ""
              }`}
            >
              <img
                src={port.img}
                alt={port.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
              <span className="absolute top-4 left-4 bg-[#E50914] text-white font-cond uppercase text-[10px] tracking-widest rounded-full px-3 py-1">
                {port.note}
              </span>
              <span className="absolute top-4 right-4 flex items-center gap-1.5 bg-[#0A0A0A]/70 backdrop-blur-sm text-white font-cond uppercase text-[10px] tracking-widest rounded-full px-3 py-1">
                <Clock size={11} className="text-[var(--hh-gold)]" /> {port.time}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-2 text-[var(--hh-gold)] mb-1">
                  <MapPin size={16} />
                  <span className="font-cond uppercase text-xs tracking-widest">{port.country}</span>
                </div>
                <h3 className="font-display uppercase text-white text-3xl">{port.name}</h3>
                <div className="flex items-start gap-2 mt-2">
                  <Compass size={15} className="text-[var(--hh-gold)] mt-0.5 shrink-0" />
                  <p className="text-white/80 text-sm leading-snug">{port.excursion}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Destinations;
